import type { CrossSellModalProps } from '~/features/cross-sells/types';
import { HubspotUpsellModal } from '~/features/cross-sells/components/HubspotUpsellModal';
import { AppProvider } from '~/providers';

export const Go1CrossSellModal = ({ onSubmit, show, onClose }: CrossSellModalProps) => (
  <AppProvider>
    <HubspotUpsellModal
      isOpen={show}
      onClose={onClose}
      title="Get more development content in less time"
      description="Talk to us about how to boost learning with curated prebuilt content within WorkRamp"
      bullets={[
        'Import from thousands of top-notch courses',
        'Add trainings from experts into Paths and Libraries',
        'Deliver and track a cohesive learner experience',
      ]}
      onSubmit={onSubmit}
      inProductDemoConversionPage="Go1 - WorkRamp Content Demo Request"
    />
  </AppProvider>
);
